module.exports = __webpack_public_path__ + "static/media/jesse_face.27bfdfa3.png";